<div class="relative py-10 sm:py-12 md:py-16 lg:py-20 xl:py-24 2xl:py-28">
    <div class="wrapper">
        <h1 class="w-full text-center">404 - Page Not Found</h1>
        <h3 class="text-lg md:text-xl text-dark font-medium text-center mt-3.5">The page you are looking for does not exist.</h3>
        <div class="flex justify-center mt-5">
            <a [routerLink]="'/'" class="px-5 py-2 text-white bg-primary rounded-md">Go to Home</a>
        </div>
    </div>
</div>